import {Component, OnInit} from "@angular/core";
import {ActivatedRoute}    from "@angular/router";
import {Language}          from "../../shared/api/languages/api.models";
import {Api}               from "../../shared/api.service";
import {ModalService}      from '../../shared/modal.service';

@Component({
    selector: 'settings-languages',
    template: require('./languages.component.html'),
    styles: [require('./languages.component.scss')]
})

export class SettingsLanguagesComponent implements OnInit {
    protected languages: Language[];
    protected filter: any = {
        language: null,
        territory : null
    };

    protected newLanguage: Language = new Language();

    constructor(private route: ActivatedRoute, private api: Api, private modal: ModalService) {}

    ngOnInit() {
        this.languages = this.route.snapshot.data['languages'];
        this.sortLanguages();
    }

    add() {
        this.api.languages().add(this.newLanguage).subscribe((language: Language) => {
            this.languages.unshift(language);
            this.sortLanguages();

            this.newLanguage = new Language();
        });
    }

    remove(language: Language) {
        this.modal.confirm('Remove language', `Are you sure you want to remove ${language.label}? ALL messages will be REMOVED!`).then(
            () => this.api.languages().remove(language.id).subscribe(() => this.languages.splice(this.languages.indexOf(language), 1)),
            () => {} // No, do nothing
        );
    }

    private sortLanguages(): void {
        this.languages.sort((a: Language, b:Language) => {
            if (a.language > b.language) {
                return 1;
            } else if (a.language < b.language) {
                return -1;
            } else if (!a.territory || a.territory < b.territory) {
                return -1;
            } else if (!b.territory || a.territory > b.territory) {
                return 1;
            }

            return 0;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/languages/languages.component.ts